import React, { useState } from 'react';
import { pexios, toast } from '../../../utils/functions';
import { history } from '../../../utils/variables';
import Modal from '../../master/Modal';
import addImage from '../../../assets/images/add_image.png';
import { useTranslation } from 'react-i18next';


export default function RegisterVideo({ registerId, type = 'user'}) {

    const { t, i18n } = useTranslation();

    const [video, setVideo] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    function uploadVideo(video) {
        setShowLoader(true);
        let fd = new FormData();
        fd.append('id', registerId);
        fd.append('video', video.files[0]);
        pexios('api/upload_register_movie','post', fd,true)
            .then(()=>{
                setShowLoader(false);
                setVideo(true);
            })
            .catch(() => {
                toast(t('Error upload video alert'), 'error');
                setShowLoader(false);
            });

    }

    function submit() {
        if (video) {
            toast(t('Successful upload video alert'));
            setTimeout(() => {
                history.replace('/')
            }, 5000);
        } else toast(t('Upload video is required'), 'error');
    }

    return (
        <>
            <Modal visible={showLoader}>
                <div className='loader-modal'>
                    <p>{t('Uploading video')}</p>
                    <i className='fas fa-spinner fa-spin' />
                </div>
            </Modal>
            <div className='mt20' style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                <p style={{fontSize:12}}>{t('20 seconds video')}</p>
                {
                    video ?
                        <i className='fas fa-check' style={{color:'green',fontSize:70,marginTop:10}} /> :
                        <label>
                            <img
                                src={addImage}
                                style={{width: 70, height: 70,marginTop:10}}
                                alt='images'
                            />
                            <input
                                type='file'
                                accept='video/*'
                                capture='camera'
                                style={{display:'none'}}
                                onChange={(e) => uploadVideo(e.target)}
                            />
                        </label>
                }
            </div>
            {
                type === 'user' &&

                <div className='mt20'>
                    <button className='btn btn-green btn-circle btn-block' onClick={submit}>
                        {t('Submit')}
                    </button>
                </div>
            }
        </>
    );

}
